import React from 'react'
import PropTypes from 'prop-types';
import LocationStore from 'stores/locationStore'
import Utils from 'common/utils';
import CommonComponents from 'components/commonComponents'
import LocationStringManager from 'manager/locationStringManager'
import SIFormatter from 'common/siFormatter';
import SidebarStateStore from 'stores/sidebarStateStore'
import NativeAgent from 'common/nativeAgent'
import DomUtils from 'common/domUtils'
import 'styles/sidebar.css'
import CacheStore from 'stores/cacheStore'
import LocationPermissionView from './locationPermissionView';
import Analytics from 'analytics';
import Constants from 'common/constants'

export default class SidebarView extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            geoLocation: LocationStore.getGeoLocationFromStore(),
            locations: LocationStore.getLocationsFromStore(),
            isUnitCelcius: this.isUnitInCelcius(props.temperature_si),
        }
        this.__manualLocListener = LocationStore.registerCbForNewManualLocation(this.newLocationHandler.bind(this))
        this.__geoLocListener = LocationStore.registerCbForNewGeoLocation(this.newGeoLocationHandler.bind(this))
        this.__sidebarListener = SidebarStateStore.registerForStateChange(this.sidebarStatusHandler.bind(this))
    }

    componentDidMount() {
        let selectedCities = document.getElementsByClassName("city-selected")
        if (false === Utils.isNull(selectedCities) && selectedCities.length > 0) {
            // NOTE: Using false purposefully. Otherwise the first(geo-location) entry was always hidden.
            // Read more about it here - https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView#Parameters
            selectedCities[0].scrollIntoView(false)
        }
    }

    componentWillReceiveProps(newProps) {
        if (newProps.temperature_si !== this.props.temperature_si) {
            this.setState({
                isUnitCelcius: this.isUnitInCelcius(newProps.temperature_si),
            })
        }
    }
    handleRedirectionToBilling = (e) => {
        NativeAgent.redirectToBilling()
        Analytics.sendEvent(
            Constants.ANALYTICS.EVENTS.CATEGORY.CLICK,
            Constants.ANALYTICS.EVENTS.ACTION.REMOVE_ADS,
            Constants.ANALYTICS.EVENTS.LABEL.SIDEBAR
        )
    }
    handleRedirectionToManageSubscription = (e) => {
        NativeAgent.redirectToManageSubscription()
    }

    handleShareClick = (e) => {
        NativeAgent.sendShareWithFriendsCall()
        Analytics.sendEvent(
            Constants.ANALYTICS.EVENTS.CATEGORY.CLICK,
            Constants.ANALYTICS.EVENTS.ACTION.SHARE,
            Constants.ANALYTICS.EVENTS.LABEL.SIDEBAR
        )
    }

    render() {
        let marginBottomClass = "sidebar-with-bottom-bar";
        var sidebarWithTopbar = "sidebar-with-topbar";
        if (false === CommonComponents.shouldSetBottomBar()) {
            marginBottomClass = "sidebar-without-bottom-bar"
        }
        if (!Utils.isWebView()) {
            sidebarWithTopbar = ""
        }

        return (
            <div>
                <div className={"city-sidebar-wrapper " + marginBottomClass}>
                    <div className={`city-wrapper city-sidebar-header-wrapper ${sidebarWithTopbar}`}>
                        <span className="icon"><img src="/image/sidebar-head.jpg" alt="weather_icon" /></span>
                    </div>
                    <div className="sidebar-scrollable-content">
                        {this.getCurrentGeoLocationElements()}
                        {this.getLocationsList()}
                    </div>
                    {this.props.isPremiumUser && this.props.showPremiumFeature && <div className="sidebar-subscription-wrapper" onClick={this.handleRedirectionToManageSubscription}>
                        <img className="subscribe-img" src="/image/subscribe-user.svg" alt="User-Img" />
                        <span className="subscribe-txt">manage subscription</span>
                    </div>}
                    {!this.props.isPremiumUser && this.props.showPremiumFeature && <div className="sidebar-subscription-wrapper" onClick={this.handleRedirectionToBilling}>
                        <img className="subscribe-img" src="/image/announcement.svg" alt="announcement" />
                        <span className="subscribe-txt">Remove ads</span>
                    </div>}
                    {this.fetchTemperatureUnits()}
                    <div className="policy-terms-wrapper share-with-friends-wrapper">
                        <div className="common-wrapper" id="share" onClick={this.handleShareClick}>
                            <img src="/image/share-icon-gray.svg" alt="share" />
                            <span className="share-text">Share with Friends</span>
                        </div>
                    </div>
                    <div className="policy-terms-wrapper">
                        <div className="common-wrapper policies">
                            <a href="https://weatherport.co/mwp/common/privacypolicy.html">Privacy Policy</a>
                        </div>
                        <div className="common-wrapper terms">
                            <a href="https://weatherport.co/mwp/common/termsofservice.html">Terms of Service</a>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    componentWillUnmount() {
        if (false === Utils.isNull(this.__sidebarListener)) {
            SidebarStateStore.unregisterListenerForKey(this.__sidebarListener)
        }

        if (false === Utils.isNull(this.__manualLocListener)) {
            LocationStore.unregisterCbNewManualLocationForKey(this.__manualLocListener)
        }

        if (false === Utils.isNull(this.__geoLocListener)) {
            LocationStore.unregisterCbNewGeoLocationForKey(this.__geoLocListener)
        }
    }


    // PRAGMA-MARK:- Location addition and removal handlers

    newLocationHandler() {
        this.setState({
            locations: LocationStore.getLocationsFromStore(),
        })
    }

    newGeoLocationHandler() {
        let newGeoLoc = LocationStore.getGeoLocationFromStore()
        this.setState({
            geoLocation: newGeoLoc,
        })

        // Refresh the current page with the new location data
        if (LocationStore.isCurrentLocationFromGeo()) {
            this.props.entry_clicked_cb(newGeoLoc, -1)
        }
    }

    removeLocationHandler = (location, locIndex) => {
        console.log("[SIDE-BAR] Removing location - ", location)
        let resp = LocationStore.removeLocationIndexAndSendLocation(locIndex, location)

        // Refresh the list
        this.newLocationHandler()
        this.newGeoLocationHandler()

        // Force a change in the location in the main page
        if (resp.status === true && resp.hasCurrentLocationChanged === true) {
            let locIndex = LocationStore.getCurrentLocationIndex()
            let location = LocationStore.getCurrentLocation()
            console.log("[DELETE-LOC] New forced location post delete - ", location)
            this.props.entry_clicked_cb(location, locIndex)
        }
    }

    // #PRAGMA-MARK :- Render location data

    getLocStr(location) {
        if (Utils.isNull(location)) {
            return "Unknown Location"
        }

        let latLonStr = Utils.formatLatLon(location.latitude, location.longitude)
        let locStr = latLonStr
        if (false === Utils.isNull(location.area)) {
            locStr = LocationStringManager.getLocationString(location.area.area, location.area.city, latLonStr)
        }
        return locStr
    }

    getLocationsList() {

        if (Utils.isNull(this.state.locations) || this.state.locations.length === 0) {
            return (
                <div></div>
            )
        }

        return this.state.locations.map((location, locIndex) => {
            let locStr = this.getLocStr(location)
            let currentSelectedLocation = LocationStore.getCurrentLocationIndex();
            return (
                <WeatherMetaView
                    key={locStr}
                    temp={null}
                    location={location}
                    locationIndex={locIndex}
                    locationData={locStr}
                    locStr={locStr}
                    icon={null}
                    entry_clicked_cb={this.props.entry_clicked_cb}
                    removeLocationHandler={this.removeLocationHandler}
                    isCurrentLocFromGeo={this.state.isCurrentLocFromGeo}
                    isUnitCelcius={this.state.isUnitCelcius}
                    currentLocationIndex={currentSelectedLocation} />
            )
        })
    }

    getCurrentGeoLocationElements() {
        // Get the geo location from store
        let locationData = this.state.geoLocation
        let locStr = this.getLocStr(locationData)
        // locStr = locStr === 'Unknown Location' ? '' : locStr
        console.log("GEO: Location data - ", locationData)
        console.log("GEO: Location string - ", locStr)
        // Add checks for geo location
        let isCurrentLocFromGeo = LocationStore.isCurrentLocationFromGeo();
        return (
            <div className="current-loc-wrapper detect-loc-wrap">
                <div className={"city-wrapper" + ((isCurrentLocFromGeo === true) ? " city-selected" : "")}>
                    <div
                        className="city-icon-wrapper"
                        onClick={() => {
                            this.props.entry_clicked_cb(locationData, -1, true)
                        }}
                    >
                        <span className="location-icon"></span>
                        <span className="city">{locStr}</span>
                        <span className="curr-loc">(Current Location)</span>
                    </div>
                    <LocationPermissionView
                        icon_clicked={() => {
                            this.props.fetch_geo_location_clicked_cb()
                            if (false === isCurrentLocFromGeo) {
                                // Add a little time delay so that it's not immediately redirecting
                                setTimeout(() => {
                                    this.props.entry_clicked_cb(locationData, -1)
                                }, 300)
                            }
                        }}
                    />
                </div>
            </div>
        )
    }

    // #PRAGMA-MARK - Temperature specific methods

    fetchTemperatureUnits() {
        let celciusClass = "btn" + ((this.state.isUnitCelcius) ? " active" : "")
        let fahrenheitClass = "btn" + ((false === this.state.isUnitCelcius) ? " active" : "")
        return (
            <div className="btn-group celsius-fer-toggle">
                <button
                    type="button"
                    className={celciusClass}
                    onClick={() => {
                        this.changeUnitHandler(true)
                    }}
                >
                    Celsius
                </button>
                <button
                    type="button"
                    className={fahrenheitClass}
                    onClick={() => {
                        this.changeUnitHandler(false)
                    }}
                >
                    Fahrenheit
                </button>
            </div>
        )
    }

    changeUnitHandler(isUnitCelcius) {
        this.setState({
            isUnitCelcius: isUnitCelcius,
        })
        this.props.temperature_unit_changed_cb()
    }

    isUnitInCelcius(unit) {
        return SIFormatter.isTempValInCelcius(SIFormatter.getTempUnitForSI(unit))
    }

    // #PRAGMA-MARK :- side-bar handlers
    sidebarStatusHandler() {
        if (SidebarStateStore.getIsSidebarOpen()) {
            setTimeout(() => {
                // Just double checking if the side-bar has not been closed immediately
                if (SidebarStateStore.getIsSidebarOpen()) {
                    this.sendNonTappableAreaDetails()
                }
            }, 500)
        } else {
            // enable pull to refresh
            NativeAgent.updatePullToRefresh(true)
        }
    }

    sendNonTappableAreaDetails() {
        console.log("BOUNDING-BOX: Calling black-list from side-bar")

        // classname list
        var blackListClassNames = [
            "weather-sidebar-wrapper"
        ];

        let boxListStr = DomUtils.getBoundingBoxListStrForClassNames(blackListClassNames)
        if (Utils.isEmptyStr(boxListStr)) {
            return
        }

        // Pushing box list into native-client
        console.log("BOUNDING-BOX: pushing into native-agent - ", boxListStr)
        NativeAgent.addBlackListBounds(boxListStr)

        // Disable pull to refresh
        NativeAgent.updatePullToRefresh(false)
    }
}

SidebarView.propTypes = {
    entry_clicked_cb: PropTypes.func.isRequired,
    temperature_unit_changed_cb: PropTypes.func.isRequired,
    temperature_si: PropTypes.string.isRequired,
    fetch_geo_location_clicked_cb: PropTypes.func.isRequired,
}

class WeatherMetaView extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            temp: props.temp,
            location: props.location,
            locationIndex: props.locationIndex,
            locationData: props.locationData,
            locStr: props.locStr,
            icon: props.icon,
            wrapperClass: props.wrapperClass,
            isUnitCelcius: props.isUnitCelcius,
            currentLocationIndex: props.currentLocationIndex
        }
    }

    componentDidUpdate(prevProperties, prevState) {
        if (prevState.isUnitCelcius !== this.props.isUnitCelcius) {
            this.setTemperatureData();
        }
    }

    setTemperatureData() {
        var reqHash = Utils.getLatLonHash(this.state.location['latitude'], this.state.location['longitude'])
        CacheStore.get(reqHash).then(cacheVal => {
            if (false === Utils.isNull(cacheVal)) {
                var regionalTemp = cacheVal['response']['currently']['temperature']
                if (this.state.isUnitCelcius) {
                    regionalTemp = SIFormatter.convertTempForSI("uk", regionalTemp)
                } else {
                    regionalTemp = SIFormatter.convertTempForSI("us", regionalTemp)
                }
                this.setState({
                    temp: regionalTemp,
                    icon: cacheVal['response']['currently']['icon'],
                    isUnitCelcius: this.props.isUnitCelcius
                });
            }
        }).catch(function (e) {
            console.log("Error getting data from cache-store" + e)
        });
    }


    componentDidMount() {
        this.setTemperatureData();
    }
    render() {
        var isCurrentSelected = (this.props.currentLocationIndex === this.state.locationIndex)
        // Setting the wrapper class
        let wrapperClass = "city-wrapper"
        if (isCurrentSelected) {
            wrapperClass = `${wrapperClass} city-selected`
        }

        var unitIcon = isCurrentSelected ? '/image/unit-celcius-blue.svg' : '/image/unit-celcius-gray.svg';
        if (this.state.isUnitCelcius === false) {
            unitIcon = isCurrentSelected ? '/image/unit-fahrenheit-blue.svg' : '/image/unit-fahrenheit-gray.svg';
        }

        return (
            <div
                className={wrapperClass}
                key={this.state.locationIndex}
            >
                <div
                    className="city-icon-wrapper"
                    onClick={() => {
                        if (false === isCurrentSelected) {
                            this.props.entry_clicked_cb(this.state.location, this.state.locationIndex, true)
                        }
                    }}
                >
                    <div className="location-icon"></div>

                    <div className="city-with-icons-temp-wrapper">
                        <div className="city">{this.state.locStr}</div>
                        <div className="icon-temp-wrapper">
                            <div className="temp">
                                <img className={"climate-icon " + this.state.icon} src={"/image/climate-icons-blue/" + this.state.icon + ".svg"} alt="" />
                                <div className="temperature"><span>{this.state.temp}</span><sup><img className="temp-icon" src={unitIcon} alt="" /></sup></div>
                            </div>
                        </div>
                    </div>

                </div>
                <div className="close-btn-wrapper">
                    <span
                        className="icon-close"
                        onClick={() => {
                            this.props.removeLocationHandler(this.state.location, this.state.locationIndex)
                        }}
                    >
                        <img src="/image/close-icon-gray.svg" alt="close_icon" />
                    </span>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/sidebarView.js